import axios, { type AxiosRequestConfig } from 'axios'
import { authService } from '../auth/AuthService'

const apiClient = axios.create({
  baseURL: import.meta.env.VITE_HOST_API_URL,
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json'
  }
})

const pendingRequests = new Map<string, Promise<any>>()

const getCacheKey = (config: AxiosRequestConfig): string => {
  const { method = 'get', url = '', params = {}, data = {} } = config
  return `${method.toUpperCase()}:${url}:${JSON.stringify(params)}:${JSON.stringify(data)}`
}

apiClient.interceptors.request.use(config => {
  const token = authService.getAccessToken()
  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }
  return config
})

const originalRequest = apiClient.request.bind(apiClient)
apiClient.request = function <T = any, R = any, D = any>(config: AxiosRequestConfig<D>): Promise<R> {
  const cacheKey = getCacheKey(config)

  if (pendingRequests.has(cacheKey)) {
    return pendingRequests.get(cacheKey)!
  }

  const requestPromise = originalRequest<T, R, D>(config)
    .then(response => {
      pendingRequests.delete(cacheKey)
      return response
    })
    .catch(error => {
      pendingRequests.delete(cacheKey)
      throw error
    })

  pendingRequests.set(cacheKey, requestPromise)
  return requestPromise
}

export default apiClient
